import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  closeModal: () => void
  onConfirm: () => void
}

const DeleteModal = ({ closeModal, onConfirm }: Props) => {
  return (
    <Modal
      illustration="delete-cross"
      title={i18n.t('settings.timeoff_blocked_periods.detail.delete.title')}
      description={i18n.t('settings.timeoff_blocked_periods.detail.delete.description')}
      onClose={closeModal}
      footer={
        <>
          <Button onClick={closeModal} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} type="negative">
            {i18n.t('common.destroy')}
          </Button>
        </>
      }
    />
  )
}

export default observer(DeleteModal)
